import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

import UsersRoutes from './UsersRoutes';
// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, UsersRoutes, LoginRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
